import React from "react";
import { Typography } from "@mui/material";

/**
 * A reusable Title component that centralizes main heading styling.
 * 
 * Example usage:
 *    <Title>Meu Título</Title>
 * or <Title variant="h3" color="red">Custom Título</Title>
 */
export const Title = ({
  variant = "h4",
  color = "#0d457c",
  align = "center",
  children,
  sx = {},
  ...rest
}) => {
  return (
    <Typography
      variant={variant}
      align={align}
      sx={{
        ...sx,
        fontWeight: "bold",
        mb: 3,
        color,
        textShadow: "1px 1px 3px rgba(0,0,0,0.2)", // subtle shadow
      }}
      {...rest}
    >
      {children}
    </Typography>
  );
};

/**
 * A reusable SubTitle component for secondary headings or section headers.
 * 
 * Example usage:
 *    <SubTitle>Seção de Configurações</SubTitle>
 * or <SubTitle variant="h6" color="#123456">Personalizado</SubTitle>
 */
export const SubTitle = ({
  variant = "h6",
  color = "#0f4983",
  align = "left",
  children,
  sx = {},
  ...rest
}) => {
  return (
    <Typography
      variant={variant}
      align={align}
      sx={{
        ...sx,
        fontWeight: "bold",
        mb: 2,                // slightly less margin
        color,
        textShadow: "0.5px 0.5px 2px rgba(0,0,0,0.2)", // even more subtle
      }}
      {...rest}
    >
      {children}
    </Typography>
  );
};
